import React, { useEffect, useState } from 'react';
import { playIntroSting, startAmbientMusic } from '../utils/audio';
import { JwflLogo } from './EwflLogo';

const SESSION_KEY = 'jwfl-intro-seen';

export const IntroSplash = ({ onDone }) => {
  const [shown, setShown] = useState(true);

  useEffect(() => {
    try { playIntroSting(); } catch {}
    try { startAmbientMusic(); } catch {}

    const fadeOut = setTimeout(() => setShown(false), 2600);
    const finish = setTimeout(() => {
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch {}
      onDone?.();
    }, 3200);

    return () => { clearTimeout(fadeOut); clearTimeout(finish); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const skip = () => {
    setShown(false);
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch {}
    setTimeout(() => onDone?.(), 300);
  };

  return (
    <div
      role="dialog"
      aria-label="JWFL intro"
      onClick={skip}
      data-testid="jwfl-intro-splash"
      className={`fixed inset-0 z-[9999] flex items-center justify-center cursor-pointer overflow-hidden transition-opacity duration-500 ${shown ? 'opacity-100' : 'opacity-0'}`}
      style={{
        background:
          'radial-gradient(ellipse at center, #0F1230 0%, #04060F 60%, #000 100%)',
      }}
    >
      {/* scanlines */}
      <div className="absolute inset-0 pointer-events-none opacity-30 mix-blend-overlay"
        style={{ backgroundImage: 'repeating-linear-gradient(0deg, rgba(0,229,255,0.06) 0 1px, transparent 1px 3px)' }} />
      {/* neon sweep */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, rgba(0,229,255,0.18) 35%, rgba(255,0,110,0.14) 65%, transparent 100%)',
          animation: 'jwfl-sweep 2.6s ease-out forwards',
        }} />
      {/* big kanji watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        style={{ zIndex: 1 }}>
        <span className="font-black"
          style={{ fontSize: '24vmin', color: 'rgba(0,229,255,0.06)', letterSpacing: '0.05em', lineHeight: 1 }}>
          日本
        </span>
      </div>

      {/* content */}
      <div className="relative flex flex-col items-center text-center px-6" style={{ zIndex: 10 }}>
        <div className="mb-7" style={{ filter: 'drop-shadow(0 0 40px rgba(0,229,255,0.85))' }}>
          <JwflLogo size={130} />
        </div>
        <h1 className="font-heading font-black tracking-[0.16em] text-6xl sm:text-8xl mb-3"
          style={{
            color: '#FFFFFF',
            textShadow: '0 0 18px rgba(0,229,255,0.95), 0 0 50px rgba(0,229,255,0.55), 0 0 6px rgba(255,0,110,0.30)',
          }}>
          JWFL
        </h1>
        <p className="text-[#00E5FF] text-xs sm:text-sm uppercase tracking-[0.42em] mb-3"
          style={{ textShadow: '0 0 14px rgba(0,229,255,0.65)' }}>
          Japan World Football League
        </p>
        <p className="text-white/85 text-sm sm:text-base mt-4 tracking-wide">
          <span className="text-[#CCFF00] font-semibold">Season 2026/27</span>
          <span className="mx-3 text-white/40">·</span>
          <span>Forge Your Dynasty</span>
        </p>

        <button onClick={skip} data-testid="intro-skip-btn"
          className="mt-10 text-[10px] uppercase tracking-[0.32em] text-white/55 hover:text-[#00E5FF] transition-colors px-5 py-2 border border-[#00E5FF]/35 rounded-sm hover:border-[#00E5FF]/80">
          Tap to enter
        </button>
      </div>

      <style>{`@keyframes jwfl-sweep { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
};

export const shouldShowIntro = () => {
  try { return sessionStorage.getItem(SESSION_KEY) !== '1'; }
  catch { return true; }
};
